import { render } from "./ProvidersDetail.vue?vue&type=template&id=664043f4&scoped=true"
import script from "./ProvidersDetail.vue?vue&type=script&lang=js"
export * from "./ProvidersDetail.vue?vue&type=script&lang=js"

import "./ProvidersDetail.vue?vue&type=style&index=0&id=664043f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664043f4"]])

export default __exports__